// extracted by mini-css-extract-plugin
export default {"card":"Fallback__card___QrsnL","button":"Fallback__button___i6CA6"};